import React from 'react'
import T from 'prop-types'
import { DragSource, DropTarget } from 'react-dnd'

const DND_ID = 'sortable_dnd_id'

// Single sortable item
class SortableItem extends React.Component {
  static displayName = 'SortableMenu.Item'

  static propTypes = {
    connectDragPreview: T.func.isRequired,
    connectDragSource: T.func.isRequired,
    connectDropTarget: T.func.isRequired,
    display: T.string.isRequired,
    findItem: T.func.isRequired,
    id: T.any.isRequired,
    index: T.number.isRequired,
    isDragging: T.bool.isRequired,
    moveItem: T.func.isRequired,
    touchBackendEnabled: T.bool
  }

  render() {
    const {
      display,
      isDragging,
      connectDragSource,
      connectDragPreview,
      connectDropTarget,
      touchBackendEnabled
    } = this.props
    let content = (
      <div
        className="sortable_menu_item"
        style={{ opacity: isDragging ? 0 : 1 }}
      >
        <span className="icon icon-drag-handle" /> {display}
      </div>
    )
    content = connectDropTarget(content)
    if (touchBackendEnabled) {
      content = connectDragPreview(content)
    }
    content = connectDragSource(content)
    // return connectDragSource(connectDropTarget(
    // ))
    return content
  }
}

const sortableItemSource = {
  beginDrag(props) {
    const { index, isActive } = props.findItem(props.id)
    return {
      id: props.id,
      display: props.display,
      originalIndex: index,
      originalIsActive: isActive
    }
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex, originalIsActive } = monitor.getItem()
    const didDrop = monitor.didDrop()
    if (!didDrop) {
      props.moveItem(droppedId, originalIndex, originalIsActive)
    }
  }
}

const sortableItemTarget = {
  canDrop() {
    return false
  },

  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem()
    const { id: overId } = props

    if (draggedId !== overId) {
      const { index: overIndex, isActive } = props.findItem(overId)
      props.moveItem(draggedId, overIndex, isActive)
    }
  }
}

const SortableItemDropTarget = DropTarget(
  DND_ID,
  sortableItemTarget,
  connect => ({
    connectDropTarget: connect.dropTarget()
  })
)(SortableItem)

const SortableItemDragSource = DragSource(
  DND_ID,
  sortableItemSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(), // Required for TouchBackend
    isDragging: monitor.isDragging()
  })
)(SortableItemDropTarget)

export default SortableItemDragSource
